import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Revokes a pending invitation, preventing it from being accepted
 * @param workspaceSlug - The workspace slug (environment)
 * @param inviteId - The ID of the invitation to revoke
 * @throws Error if invitation cannot be revoked (already accepted/expired/revoked)
 */
export async function revokeInvite(
  workspaceSlug: string,
  inviteId: string,
): Promise<void> {
  await AuthAxios.delete(`/api/v1.0/e/${workspaceSlug}/invites/${inviteId}`)
}
